<template>
  <div class="input-container">
    <Autocomplete :options="availableMembers.map(el => ({value: el.Guid, label: el.Label}))"
                  :placeholder="selectedMember && selectedMember.Label"
                  @select="updateSelectedMember"></Autocomplete>
    <button class="undo-btn" @click="goBack" :disabled="!selectedMemberGuid"><font-awesome-icon icon="undo"></font-awesome-icon></button>
    <button class="reset-btn" @click="$emit('update', '')" :disabled="!selectedMemberGuid"><font-awesome-icon icon="ban"></font-awesome-icon></button>
  </div>
</template>

<script>
  import Autocomplete from "./Autocomplete"

  export default {
    name: "SubstituteAdh",
    props: ["members", "selectedMemberGuid"],
    components: { Autocomplete },
    mounted() {
      this.$emit("update", this.$store.state.self.guid);
    },
    computed: {
      me() {
        let minLevel = this.members.reduce((acc, el) => el.Level < acc ? el.Level : acc, 5)
        if (this.$store.state.self.isAdmin && minLevel === 1 && this.members.filter(el => el.Level === minLevel).length > 1) {
          minLevel = 0; // CMEM
        }
        return this.members.find(el => el.Level === minLevel) || ({ Name: "Admin", Level: 0, Label: "[A] Admin", Guid: "00000000-0000-0000-0000-000000000000" });
      },
      selectedMember() {
        if (!this.selectedMemberGuid) return this.me
        return this.members.find(el => el.Guid === this.selectedMemberGuid) || this.me
      },
      availableMembers() {
        return this.members
          .filter(el => el.Level === this.selectedMember.Level + 1
            && (el.GroupeGuid === this.selectedMember.Guid
              || el.SousGroupeGuid === this.selectedMember.Guid
              || el.SocieteGuid === this.selectedMember.Guid
              || this.selectedMember.Level === 0
            ))
          .slice()
          .sort((a, b) => {
            if (a.Name.slice(0, 1) == "_") return -1;
            else if (b.Name.slice(0, 1) == "_") return 1;
            return a.Label < b.Label ? -1 : 1
          })
      }
    },
    methods: {
      updateSelectedMember(adhGuid) {
        this.$emit("update", adhGuid);
      },
      goBack() {
        if (this.selectedMemberGuid) {
          let newMemberGuid = this.selectedMember.SocieteGuid || this.selectedMember.SousGroupeGuid || this.selectedMember.GroupeGuid || '';
          if (newMemberGuid === (this.me ? this.me.Guid : ""))
            newMemberGuid = ""
          this.$emit("update", newMemberGuid);
        }
      }
    }
  }
</script>

<style scoped>
  .input-container {
    display: flex;
    border-collapse: collapse;
  }

  .undo-btn {
    border-radius: 0;
    border-color: #CCC;
    border-left: none;
    border-right: none;
    background-color: #FF9800;
    color: #FFFFFF;
  }

  .reset-btn {
    border-radius: 6px;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    border-color: #CCC;
    border-left: none;
    background-color: #FF5252;
    color: #FFFFFF;
  }
  btn[disabled]:hover {
    cursor: default;
  }

</style>



// WEBPACK FOOTER //
// src/components/SubstituteAdh.vue